import request from '@/axios'

export function createInventoryApi (payload) {
  return request({
    url: 'assets/create_inventory',
    method: 'POST',
    data: payload
  })
}

export function createRoomApi (payload) {
  return request({
    url: 'assets/create_room',
    method: 'POST',
    data: payload
  })
}

// {{url}}/assets/list_inventory/{{customer_id}}/Inventory OR Room

export function inventoryOrRoomListApi (customer_id, types, queryParams, payload = null) {
  
  return request({
    url: `/assets/list_inventory/${customer_id}/${types}?attribute=${queryParams.attribute?queryParams.attribute:''}&direction=${queryParams.direction?queryParams.direction:''}&field_type=${queryParams.field_type?queryParams.field_type:''}&table_name=${queryParams.table_name?queryParams.table_name:''}&page=${queryParams.current_page}`,
    method: 'POST',
    data: payload
  })
}
export function RoomListApi (customer_id, types, queryParams, payload = null) {
  
  
  return request({
    url: `/assets/list_room/${customer_id}/${types}?attribute=${queryParams.attribute?queryParams.attribute:''}&direction=${queryParams.direction?queryParams.direction:''}&field_type=${queryParams.field_type?queryParams.field_type:''}&table_name=${queryParams.table_name?queryParams.table_name:''}&page=${queryParams.current_page}`,
    method: 'POST',
    data: payload
  })
}

// http://cx-lms-api-dev.track-progress.com/api/assets/list_room/102/Room

// getInventoryListByType
export function inventoryListTypeAPI (customer_id, types) {
  return request({
    url: `assets/list_inventory_by_type/${customer_id}/${types}`,
    method: 'GET'
  })
}

export function updateInventory (payload) {
  return request({
    url: '/assets/edit_inventory',
    method: 'PUT',
    data: payload
  })
}

export function updateRoom (payload) {
  return request({
    url: '/assets/edit_room',
    method: 'PUT',
    data: payload
  })
}

// {{url}}/assets/delete_inventory ---- DELETE

export function deleteInventoryApi (payload) {
  return request({
    url: '/assets/delete_inventory',
    method: 'DELETE',
    data: payload
  })
}
export function deleteRoomApi (payload) {
  return request({
    url: '/assets/delete_room',
    method: 'DELETE',
    data: payload
  })
}
 

// {{url}}/assets/edit_inventory ----- PUT

// {{url}}/assets/list_inventory/{{customer_id}}/Inventory OR Room --- GET

export function fetchingInventoryApi () {
  return request({
    url: 'assets/create_inventory',
    method: 'GET'
  })
}

// {{url}}/assets/delete_inventory

export function createAssetsCategoryApi (payload) {
  return request({
    url: '/assets/create_assets_category',
    method: 'POST',
    data: payload
  })
}

export function fetchingAssetsCategoryApi (customer_id, payload = null) {
  return request({
    url: `/assets/list_assets_category/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function fetchingInventoryNameApi (customer_id) {
  return request({
    url: `/assets/list-all-inventory-short/${customer_id}`,
    method: 'GET'
  })
}


export function fetchingAssetsInventoryName (customer_id, payload = null) {
  return request({
    url: `/assets/list-of-course-assets/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

